// Polyfill for Object.groupBy (ES2024)
export const groupBy = <K extends PropertyKey, T>(
  items: Iterable<T>,
  keySelector: (item: T, index: number) => K
): Partial<Record<K, T[]>> => {
  return Array.from(items).reduce(
    (acc, item, index) => {
      const key = keySelector(item, index)
      acc[key] = [...(acc[key] || []), item]
      return acc
    },
    {} as Record<K, T[]>
  )
}

// duplicated in file://./../../../api/src/utils/collections.ts
// duplicated in file://./../../../etc/fileconversion/src/utils.ts
export const partition = <T>(array: T[], size: number): T[][] => {
  const result: T[][] = []
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size))
  }
  return result
}

// Polyfill for Array.prototype.findLast (ES2023)
// duplicated in file://./../../../api/src/utils/index.ts
export const findLast = <T>(
  array: T[] | undefined,
  predicate: (value: T, index: number, array: T[]) => boolean
): T | undefined => {
  if (!array?.length) {
    return undefined
  }
  for (let i = array.length - 1; i >= 0; i--) {
    const item = array[i]
    if (item !== undefined && predicate(item, i, array)) {
      return item
    }
  }
  return undefined
}

// Polyfill for Array.prototype.findLastIndex (ES2023)
// duplicated in file://./../../../api/src/utils/index.ts
export const findLastIndex = <T>(
  array: T[],
  predicate: (value: T, index: number, array: T[]) => boolean
): number => {
  for (let i = array.length - 1; i >= 0; i--) {
    const item = array[i]
    if (item !== undefined && predicate(item, i, array)) {
      return i
    }
  }
  return -1
}

// Polyfill for Set.prototype.difference (ES2025)
export const setDifference = <T>(setA: Set<T>, setB: Set<T>): Set<T> => {
  const result = new Set<T>()
  for (const item of setA) {
    if (!setB.has(item)) {
      result.add(item)
    }
  }
  return result
}

// Polyfill for Iterator.prototype.toArray (ES2025)
// Converts a Map values iterator to an array
export const iteratorToArray = <T>(iterator: IterableIterator<T>): T[] => {
  return Array.from(iterator)
}
